/* eslint-disable */
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  TextFieldProps,
  Button,
} from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { useContext, useEffect, useState } from 'react'
import TextfieldAndUpload from './FileUploadAndList'
import AlertPageDataList from '../AlertPage/AlertPageDataList'
import { OrgAppContext } from '../../OrgAppContext'
import { useTranslation } from 'react-i18next'
import { useApiPost } from '../../apiCalls/useApi'
import { updateBreach } from '../../apiCalls/breachApi'

const dateInputStyle = {
  svg: { fontSize: '18px' },
  '.MuiInputLabel-root': {
    color: '#5B5B5B',
    transform: 'translate(14px, 16px) scale(1)',
    '&.Mui-focused, &.MuiFormLabel-filled': {
      transform: 'translate(14px, -9px) scale(0.75)',
    },
  },
  '.MuiInputBase-input': {
    color: '#5B5B5B',
    padding: '8px 14px',
  },
  '.MuiOutlinedInput-root': {
    height: '56px',
    width: '220px',
  },
}

export default function BreachDetails({ breachDetails }: any) {
  if (!breachDetails || !breachDetails?.breachInfo || !breachDetails?.attachments) return null
  const { breachInfo, attachments } = breachDetails
  const [breachName, setBreachName] = useState(breachInfo.breachName)
  const [reportDate, setReportDate] = useState<Date | null>(
    breachInfo.reportDate ? dayjs(breachInfo.reportDate).toDate() : null
  )
  const [openDate, setOpenDate] = useState<Date | null>(
    breachInfo.openDate ? dayjs(breachInfo.openDate).toDate() : null
  )
  const [breachDateRange, setBreachDateRange] = useState({
    start: breachInfo.breachDateStart ? dayjs(breachInfo.breachDateStart).toDate() : null,
    end: breachInfo.breachDateEnd ? dayjs(breachInfo.breachDateEnd).toDate() : null,
  })
  const [severity, setSeverity] = useState(breachInfo.severity || null)
  const [breachStatus, setBreachStatus] = useState(breachInfo.status || null)
  const [description, setDescription] = useState(breachInfo.description || null)
  const [potentialImpactText, setPotentialImpactText] = useState(breachInfo.potentialImpact || null)
  const [affectedClientsText, setAffectedClientsText] = useState(breachInfo.affectedClients || null)
  const [affectedOrganizationsText, setAffectedOrganizationsText] = useState(
    breachInfo.affectedOrganizations || null
  )
  const [breachReportText, setBreachReportText] = useState(breachInfo.breachReport || null)
  const [potentialImpactFiles, setPotentialImpactFiles] = useState<any>([])
  const [affectedClientsFiles, setAffectedClientsFiles] = useState<any>([])
  const [affectedOrganizationsFiles, setAffectedOrganizationsFiles] = useState<any>([])
  const [breachReportFiles, setBreachReportFiles] = useState<any>([])
  const { t } = useTranslation()
  const [alertData, setAlertData] = useState<any>({
    data: [],
    pageInfo: {},
  })

  const updateBreachDetail = useApiPost(updateBreach)
  const { orgName, appId, appName } = useContext(OrgAppContext)

  const alertList = alertData.data
    ? {
        ...alertData,
        data: breachInfo.alerts.map((e: any) => ({
          ...e,
          riskLevel: t('riskLevels.' + e.riskLevel),
          statusText: t('alertStatusList.' + e.status),
          orgName: orgName,
          appName: appName,
          confirmationText:
            e.confirmation === 'WAITING' ? '' : t('alertConfirmationList.' + e.confirmation),
        })),
      }
    : []

  useEffect(() => {
    if (attachments) {
      setPotentialImpactFiles(attachments.filter((a: any) => a.relationType === 'potential_impact'))
      setAffectedClientsFiles(attachments.filter((a: any) => a.relationType === 'affected_clients'))
      setAffectedOrganizationsFiles(
        attachments.filter((a: any) => a.relationType === 'affected_organizations')
      )
      setBreachReportFiles(attachments.filter((a: any) => a.relationType === 'breach_report'))
    }
  }, [attachments])

  const handleSave = () => {
    const payload = {
      breachId: breachInfo.id,
      breachName: breachName,
      reportDate: reportDate ? dayjs(reportDate).format('YYYY-MM-DD') : null,
      openDate: openDate ? dayjs(openDate).format('YYYY-MM-DD') : null,
      breachDateStart: breachDateRange.start
        ? dayjs(breachDateRange.start).format('YYYY-MM-DD')
        : null,
      breachDateEnd: breachDateRange.end ? dayjs(breachDateRange.end).format('YYYY-MM-DD') : null,
      severity: severity,
      status: breachStatus,
      description: description,
      potentialImpact: potentialImpactText,
      affectedClients: affectedClientsText,
      affectedOrganizations: affectedOrganizationsText,
      breachReport: breachReportText,
    }
    updateBreachDetail(payload).then((res: any) => {
      if (res?.error) return
    })
  }

  return (
    <Box sx={{ padding: '0px 10px 10px 10px' }}>
      <div
        style={{
          position: 'sticky',
          top: '0',
          backgroundColor: '#ffffff',
          zIndex: 999,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='h6'>Breach Information</Typography>
        <Button
          variant='contained'
          sx={{ marginRight: '10px', width: '100px' }}
          onClick={handleSave}
        >
          Save
        </Button>
      </div>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '20px' }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            <TextField
              label='Breach Name'
              value={breachName}
              onChange={(e) => setBreachName(e.target.value)}
            />
            <DatePicker
              label='Report Date'
              value={reportDate}
              onChange={(newValue: Date | null) => setReportDate(newValue)}
              renderInput={(params: TextFieldProps) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <TextField {...params} sx={dateInputStyle} />
              )}
            />
            <DatePicker
              label='Open Date'
              value={openDate}
              onChange={(newValue: Date | null) => setOpenDate(newValue)}
              renderInput={(params: TextFieldProps) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <TextField {...params} sx={dateInputStyle} />
              )}
            />
            <DatePicker
              label='Breach Date Start'
              value={breachDateRange.start}
              onChange={(newValue) => setBreachDateRange((prev) => ({ ...prev, start: newValue }))}
              renderInput={(params: TextFieldProps) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <TextField {...params} sx={dateInputStyle} />
              )}
            />
            <DatePicker
              label='Breach Date End'
              value={breachDateRange.end}
              onChange={(newValue) => setBreachDateRange((prev) => ({ ...prev, end: newValue }))}
              renderInput={(params: TextFieldProps) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <TextField {...params} sx={dateInputStyle} />
              )}
            />
            <FormControl sx={{ maxWidth: '200px', flex: 1 }}>
              <InputLabel>Severity</InputLabel>
              <Select
                value={severity}
                label='Severity'
                onChange={(e) => setSeverity(e.target.value)}
              >
                <MenuItem value='HIGH'>HIGH</MenuItem>
                <MenuItem value='MEDIUM'>MEDIUM</MenuItem>
                <MenuItem value='LOW'>LOW</MenuItem>
              </Select>
            </FormControl>

            <FormControl sx={{ maxWidth: '200px', flex: 1 }}>
              <InputLabel>Breach Status</InputLabel>
              <Select
                value={breachStatus}
                label='Breach Status'
                onChange={(e) => setBreachStatus(e.target.value)}
              >
                <MenuItem value='OPEN'>OPEN</MenuItem>
                <MenuItem value='CLOSED'>CLOSED</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </LocalizationProvider>

        <TextField
          label='Description'
          multiline
          rows={8}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          sx={{ width: '100%' }}
        />
        <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          <TextField
            label='Potential Impact'
            multiline
            rows={9}
            value={potentialImpactText}
            onChange={(e) => setPotentialImpactText(e.target.value)}
            sx={{ width: '65%' }}
          />
          <TextfieldAndUpload fileList={potentialImpactFiles} />
        </Box>

        <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          <TextField
            label='Affected Clients'
            multiline
            rows={9}
            value={affectedClientsText}
            onChange={(e) => setAffectedClientsText(e.target.value)}
            sx={{ width: '65%' }}
          />
          <TextfieldAndUpload fileList={affectedClientsFiles} />
        </Box>
        <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          <TextField
            label='Affected Organizations'
            multiline
            rows={9}
            value={affectedOrganizationsText}
            onChange={(e) => setAffectedOrganizationsText(e.target.value)}
            sx={{ width: '65%' }}
          />
          <TextfieldAndUpload fileList={affectedOrganizationsFiles} />
        </Box>
        <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          <TextField
            label='Breach Report'
            multiline
            rows={9}
            value={breachReportText}
            onChange={(e) => setBreachReportText(e.target.value)}
            sx={{ width: '65%' }}
          />
          <TextfieldAndUpload fileList={breachReportFiles} />
        </Box>
        {alertList.data.length > 0 && (
          <>
            <Typography variant='h6'>Related Alerts</Typography>

            <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
              <AlertPageDataList data={alertList} appId={appId} />
            </Box>
          </>
        )}
      </Box>
    </Box>
  )
}
